import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Family from "../Forms/C/Family/Family"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const FamilyContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)

  const userCtx = useContext(UserContext)
  const [isGettingFamily, setIsGettingFamily] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingFamily(true)
      handleSubmitGet(endpoints.GET_FAMILY_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.FAMILY)
          handleLoadPrev(false)
          setIsGettingFamily(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingFamily(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const setValues = (data) => {
    return {
      gpra_c_1: data?.form?.gpraC1 ?? "",
      gpra_c_1a: data?.form?.gpraC1a ?? "",
      gpra_c_1b: data?.form?.gpraC1b ?? "",
      gpra_c_2: data?.form?.gpraC2 ?? "",
      gpra_c_id: data?.form?.gpraCId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingFamily) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingFamily && (
        <Family showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default FamilyContainer
